import React from 'react';
import classNames from 'classnames/bind';
import { Button } from '@carnica/ui-kit';
import { IconCloseRoundStroked, IconSearchOutline } from '@carnica/graphics';
import { useIsDesktopDimension } from '@beef/ui-kit';
import { Metric } from "../../../../metric";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ActionBar = function ActionBar(_ref) {
  var onCloseButtonClick = _ref.onCloseButtonClick,
    onSearchButtonClick = _ref.onSearchButtonClick,
    isSearchStep = _ref.isSearchStep;
  var isDesktop = useIsDesktopDimension();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    events: {
      headerMetric: ['handleCloseNavClick']
    },
    mode: "click",
    "data-t-id": "components-ActionBar"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('action-button'),
    iconLeft: IconCloseRoundStroked,
    onClick: onCloseButtonClick,
    onlyIcon: true,
    size: "m",
    view: "tertiary",
    "data-t-id": "components-ActionBar"
  })), !isDesktop && /*#__PURE__*/React.createElement(Button, {
    className: cn('action-button', {
      'action-button__search--active': isSearchStep
    }),
    iconLeft: IconSearchOutline,
    onClick: onSearchButtonClick,
    onlyIcon: true,
    size: "m",
    view: isSearchStep ? 'secondary' : 'tertiary'
  }));
};